import OtherAppsIcon from "@assets/icons/otherApps"
import { useLocation } from "react-router"
import CurrentSelectedIconWrapper from "./CurrentSelectedIconWrapper"
import { Link } from "react-router-dom"
import ManagePatientIcon from "@assets/icons/managePatient"
import ManageAppointmentIcon from "@assets/icons/manageAppointment"
import DashBoardIcon from "@assets/icons/dashBoardIcon"
import MyAccountIcon from "@assets/icons/myAccount"

const SideBarItem = ({
  route,
  showText,
  linkClassName = "",
  linkActiveClassName = "",
}) => {
  const pathName = useLocation().pathname

  return (
    <>
      {route === "/other-apps" && route === pathName ? (
        <Link to={route} className={linkClassName + " " + linkActiveClassName}>
          <CurrentSelectedIconWrapper>
            <OtherAppsIcon stroke="#fff" />
          </CurrentSelectedIconWrapper>
          {showText ? "OTHER APPS" : null}
        </Link>
      ) : null}

      {route === "/other-apps" && route !== pathName ? (
        <Link to={route} className={linkClassName}>
          <OtherAppsIcon />
          {showText ? "OTHER APPS" : null}
        </Link>
      ) : null}

      {route === "/manage-patient-vision" && pathName.includes(route) ? (
        <Link to={route} className={linkClassName + " " + linkActiveClassName}>
          <CurrentSelectedIconWrapper>
            <ManagePatientIcon stroke="#fff" />
          </CurrentSelectedIconWrapper>
          {showText ? "MANAGE PATIENT" : null}
        </Link>
      ) : null}

      {route === "/manage-patient-vision" && !pathName.includes(route) ? (
        <Link to={route} className={linkClassName}>
          <ManagePatientIcon />
          {showText ? "MANAGE PATIENT" : null}
        </Link>
      ) : null}

      {route === "/manage-appointment" && pathName.includes(route) ? (
        <Link to={route} className={linkClassName + " " + linkActiveClassName}>
          <CurrentSelectedIconWrapper>
            <ManageAppointmentIcon stroke="#fff" />
          </CurrentSelectedIconWrapper>
          {showText ? "MANAGE APPOINTMENT" : null}
        </Link>
      ) : null}

      {route === "/manage-appointment" && !pathName.includes(route) ? (
        <Link to={route} className={linkClassName}>
          <ManageAppointmentIcon />
          {showText ? "MANAGE APPOINTMENT" : null}
        </Link>
      ) : null}

      {route === "/dashboard" && route === pathName ? (
        <Link to={route} className={linkClassName + " " + linkActiveClassName}>
          <CurrentSelectedIconWrapper>
            <DashBoardIcon stroke="#fff" />
          </CurrentSelectedIconWrapper>
          {showText ? "DASHBOARD" : null}
        </Link>
      ) : null}

      {route === "/dashboard" && route !== pathName ? (
        <Link to={route} className={linkClassName}>
          <DashBoardIcon />
          {showText ? "DASHBOARD" : null}
        </Link>
      ) : null}

      {route === "/my-account" && route === pathName ? (
        <Link to={route} className={linkClassName + " " + linkActiveClassName}>
          <CurrentSelectedIconWrapper>
            <MyAccountIcon stroke="#fff" />
          </CurrentSelectedIconWrapper>
          {showText ? "MY ACCOUNT" : null}
        </Link>
      ) : null}

      {route === "/my-account" && route !== pathName ? (
        <Link to={route} className={linkClassName}>
          <MyAccountIcon />
          {showText ? "MY ACCOUNT" : null}
        </Link>
      ) : null}
    </>
  )
}

export default SideBarItem
